import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    inject,
    Input,
    OnInit,
    Output,
    SecurityContext,
} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {I18NextPipe} from "@kokos-i18next";
import {NachrichtActionButtonsComponent} from '../nachricht-action-buttons/nachricht-action-buttons.component';
import {NachrichtAction} from '../nachricht-action-buttons/nachricht-action.enum';
import {ExtendedAnhang} from '../../../core/model/nachricht/nachricht';
import i18next from 'i18next';

@Component({
    selector: 'pf-nachricht-detail',
    imports: [NachrichtActionButtonsComponent, I18NextPipe],
    templateUrl: './nachricht-detail.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NachrichtDetailComponent implements OnInit {
    @Input() nachrichtId!: string;
    @Input() dateTime!: string;
    @Input() sender!: string;
    @Input() autor: string;
    @Input() empfaenger: string;
    @Input() text: string = '';
    @Input() betreff?: string;
    @Input() betreffSmall = false;
    @Input() nachrichtActions: NachrichtAction[] = [];
    @Input() anhaenge?: ExtendedAnhang[];
    @Input() anhaengeNamen?: string[];

    @Output() downloadClicked = new EventEmitter<number>();
    @Output() buttonClicked = new EventEmitter<NachrichtAction>();

    private readonly domSanitizer = inject(DomSanitizer);

    trustedText: SafeHtml = '';

    protected readonly i18next = i18next;

    ngOnInit(): void {
        this.trustedText = this.domSanitizer.sanitize(SecurityContext.HTML, this.text) ?? '';
    }

    getAttachmentsLabel(): string | null {
        const list = this.anhaenge ?? this.anhaengeNamen;
        if (!list) return null;
        return list.length === 1
            ? i18next.t('nachricht.attachment')
            : i18next.t('nachricht.attachments');
    }
}